<template>
  <section class="admin-content" id="facilities-dashboard">
    <Navbar />
    <main class="admin-main">
      <div class="page-header">
        <div class="container">
          <div class="d-flex flex-wrap align-items-center text-white" style="padding: 32px 0; gap: 12px;">
            <div class="header-icon-wrap"><i class="fe fe-activity" style="font-size: 22px;"></i></div>
            <div class="flex-grow-1">
              <h4 class="mb-0 font-weight-bold">Provider Dashboard</h4>
              <small style="opacity: 0.8;">How the agency's health facilities perform: utilization, referrals, claims, ratings and risk</small>
            </div>
            <router-link to="/my-providers" class="btn btn-light btn-sm font-weight-bold px-3"><i class="fe fe-list mr-1"></i> Health Facilities</router-link>
          </div>
        </div>
      </div>
      <section style="margin-top: -20px;">
        <div class="container pb-5">
          <div class="row mb-2">
            <div class="col-6 col-lg-3 mb-3" v-for="l in links" :key="l.to">
              <router-link :to="l.to" class="card shadow-sm h-100 quick-link">
                <div class="card-body py-3 d-flex align-items-center" style="gap: 12px;">
                  <i class="fe" :class="l.icon" :style="{ color: l.color }"></i>
                  <div><div class="font-weight-bold">{{ l.title }}</div><small class="text-muted">{{ l.hint }}</small></div>
                </div>
              </router-link>
            </div>
          </div>
          <FacilityDashboard />
          <CofAnalytics />
        </div>
      </section>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import FacilityDashboard from "./components/FacilityDashboard.vue";
import CofAnalytics from "./components/CofAnalytics.vue";

/** Provider (facility) analytics in one place; the facilities list itself stays on /my-providers. */
export default {
  components: { Navbar, FacilityDashboard, CofAnalytics },
  data() {
    return {
      links: [
        { to: "/my-providers", title: "Health Facilities", hint: "List, search, add", icon: "fe-home", color: "#2563eb" },
        { to: "/facility-risk", title: "Facility Risk", hint: "Claim risk scores", icon: "fe-alert-triangle", color: "#dc2626" },
        { to: "/providers/zero-enrollees", title: "Zero-Enrollee Facilities", hint: "Review and disapprove", icon: "fe-slash", color: "#d97706" },
        { to: "/change-facility-requests", title: "Change of Facility", hint: "Requests from enrollees", icon: "fe-repeat", color: "#7c3aed" },
      ],
    };
  },
};
</script>

<style scoped>
@import "../reports/reports.css";
.quick-link { border-radius: 12px; border: 1px solid #e9ecef; color: #1e293b; text-decoration: none; }
.quick-link:hover { border-color: #93c5fd; }
.quick-link i { font-size: 1.5rem; }
</style>
